import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { Message, ActiveConnection } from '../../models/message'

@Injectable({
    providedIn: 'root'
})

export class TransferDataService {
    showHideBtn: string = 'SS';
    isClientConnect: boolean = false;
    isClientDisconnect: boolean = false;
    connectionStatus: number = 0;
    isNavAction: boolean = false;
    message: Message;
    contractInitiate: boolean = false;
    showContractRemote: boolean = false;
    fileNumber: string = '';
    isFileNoBlank: boolean = false;
    isSendToCorp: boolean = false;
    isChangedFileNumber: boolean = false;
    constructor(private httpClient: HttpClient) {

    }

}
